import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';


import { DireccionesGeograficaIDEService } from '../entity-direcciones-geografica-ide/direcciones-geografica-ide.service';
import {
  entityDireccionGeograficaExactaIDELoadFailure,
  entityDireccionGeograficaExactaIDELoadRequest,
  entityDireccionGeograficaExactaIDELoadSuccess
} from './entity-direcciones-geografica-ide.actions';

@Injectable()
export class DireccionesGeograficaIDEExactaEffects {
  // load
  loadRequestDireccionesGeograficaIDEExacta = createEffect(() =>
    this.actions$.pipe(
      ofType(entityDireccionGeograficaExactaIDELoadRequest),
      switchMap((action) =>
        this.direccionesGeograficaIDEService
          .getDireccionesGeograficaExactaIDE(action.d)          
          .pipe(
            map(items => entityDireccionGeograficaExactaIDELoadSuccess({ items }),           
            catchError((error) =>
              of(entityDireccionGeograficaExactaIDELoadFailure({ error }))
            ))
          )        
      )
    )
  );

  constructor(
    private actions$: Actions,    
    private direccionesGeograficaIDEService: DireccionesGeograficaIDEService
  ) {}
}
